import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { superstyled } from '@zenbusiness/zui/styles';

export const EmailIcon = superstyled({
  name: 'EmailVerificationBannerEmailIcon',
  slot: 'Root',
  tag: EmailOutlinedIcon,
  styles: ({ theme }) => ({
    color: theme.palette.text.primary,
    fontSize: 32,
  }),
});

export const SubtitleDetails = superstyled({
  name: 'EmailVerificationBannerSubtitleDetails',
  slot: 'Details',
  tag: 'span',
  styles: ({ theme }) => ({
    display: 'block',
    marginTop: theme.spacing(1),
  }),
});
